// src/components/tabs/DialoguesTab.jsx
import React from 'react';

function DialoguesTab({ movie }) {
  if (!movie) return <div>No movie selected</div>;
  
  // Check if dialogues exist and aren't error messages
  const hasValidDialogues = movie.dialogues && 
                           Array.isArray(movie.dialogues) && 
                           movie.dialogues.length > 0 &&
                           movie.dialogues[0].character !== "System";
  
  // Use actual dialogues from the API if available, otherwise use fallback
  const dialogues = hasValidDialogues ? movie.dialogues : [
    { 
      character: "Main Character", 
      quote: "This is where I would say the most iconic line from the movie.", 
      context: "Climactic scene" 
    },
    { 
      character: "Supporting Character", 
      quote: "And this is where I would respond with something meaningful.", 
      context: "Climactic scene" 
    },
    { 
      character: "Villain", 
      quote: "This would be the villain's most memorable threat or monologue.", 
      context: "Confrontation scene" 
    },
    { 
      character: "Comic Relief", 
      quote: "And here's where I would say something to lighten the mood.", 
      context: "After tense moment" 
    }
  ];
  
  return (
    <div className="dialogues-tab">
      <h2>Memorable Dialogues</h2>
      
      <div className="dialogues-list">
        {dialogues.map((dialogue, index) => (
          <div key={index} className="dialogue-item">
            <div className="dialogue-character">{dialogue.character}</div>
            <blockquote className="dialogue-quote">"{dialogue.quote}"</blockquote>
            {dialogue.context && (
              <div className="dialogue-context">— {dialogue.context}</div>
            )}
          </div>
        ))}
      </div>
      
      {!hasValidDialogues && (
        <div className="dialogues-note">
          <p>Note: Generated dialogues are not available for this movie. Showing placeholder content instead.</p>
        </div>
      )}
    </div>
  );
}

export default DialoguesTab;